import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconBedFilled: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 12.8005V6.00049C21 4.30049 19.7 3.00049 18 3.00049H6C4.3 3.00049 3 4.30049 3 6.00049V12.8005C2.4 13.3005 2 14.1005 2 15.0005V21.0005C2 21.6005 2.4 22.0005 3 22.0005C3.6 22.0005 4 21.6005 4 21.0005V20.0005H20V21.0005C20 21.6005 20.4 22.0005 21 22.0005C21.6 22.0005 22 21.6005 22 21.0005V15.0005C22 14.1005 21.6 13.3005 21 12.8005ZM5 6.00049C5 5.40049 5.4 5.00049 6 5.00049H18C18.6 5.00049 19 5.40049 19 6.00049V12.0005H18V8.00049C18 7.40049 17.6 7.00049 17 7.00049H12H7C6.4 7.00049 6 7.40049 6 8.00049V12.0005H5V6.00049ZM8 12.0005V9.00049H11V12.0005H8ZM13 9.00049H16V12.0005H13V9.00049Z',
    })
  )
}
